function buildCategoryPath(category, allCategories = [], visited = new Set()) {
  if (!category) return '';
  if (visited.has(category.databaseId)) {
    // Circular dependency detected
    return '';
  }
  visited.add(category.databaseId);
  const parent = allCategories.find(cat => cat.databaseId === category.parentDatabaseId);
  return parent ? `${buildCategoryPath(parent, allCategories, visited)}/${category.slug}` : category.slug;
}

function getTopLevelCategory(category, allCategories) {
  if (!category || !allCategories || allCategories.length === 0) {
    return category || { name: "Uncategorized", slug: "uncategorized" };
  }

  // If category has no parentDatabaseId, it's a top-level category
  if (!category.parentDatabaseId) {
    return category;
  }

  const parent = allCategories.find(cat => cat.databaseId === category.parentDatabaseId);

  // If parent is found, recursively find its top-level parent
  if (parent) {
    return getTopLevelCategory(parent, allCategories);
  }

  // If parent not found, return the current category (it might be a top-level category that just doesn't have its parent in the list)
  return category;
}

function getCategoryDepth(category, allCategories) {
  if (!category || !category.parentDatabaseId) {
    return 0;
  }
  const parent = allCategories.find(cat => cat.databaseId === category.parentDatabaseId);
  if (!parent) {
    return 0;
  }
  return 1 + getCategoryDepth(parent, allCategories);
}

module.exports = { buildCategoryPath, getTopLevelCategory, getCategoryDepth };